import React from "react";
import ReactDOM from "react-dom/client";
import Users from "./Containers/Users";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Users />
  </React.StrictMode>
);
